import { Col, Form, FormInstance, Row } from 'antd';
import { isAfter } from 'date-fns';
import { useTranslation } from 'react-i18next';
import DatePicker from '../../../../shared/components/date-picker/date-picker';
import { useGetUserSettingsQuery } from '../../../user/api/user-api';
import { UserSettings } from '../../../user/models/user-settings';
import { parseServerDateFormat } from '../../../../shared/utils/format-date/format-date';
import { SignDocumentsFilterFormModel } from '../../models/sign-documents-filter-form-model';
import ClientUsersUnitSelect from '../../../client-users/components/client-users-unit-select/client-users-unit-select';

interface Props {
  form: FormInstance<SignDocumentsFilterFormModel>;
  onFinish: (values: SignDocumentsFilterFormModel) => void;
  formId: string;
  hasUnitSelect?: boolean;
}

const SignDocumentsFilterForm = ({ form, onFinish, formId, hasUnitSelect = false }: Props): JSX.Element => {
  const { t } = useTranslation(['dashboard', 'common']);
  const { data: userSettings } = useGetUserSettingsQuery();

  return (
    <Form id={formId} form={form} layout="vertical" onFinish={onFinish}>
      <Row gutter={16}>
        <Col>
          <Form.Item name="dateFromTo" label={t('label.date')}>
            <DatePicker.RangePicker
              style={{ width: '100%' }}
              disabledDate={date => isAfter(date, new Date())}
              format={parseServerDateFormat(userSettings?.[UserSettings.DateFormat])}
            />
          </Form.Item>
        </Col>
        {hasUnitSelect && (
          <Col flex="auto">
            <Form.Item name="unit" label={t('label.unit')}>
              <ClientUsersUnitSelect placeholder={t('placeholder.unit')} />
            </Form.Item>
          </Col>
        )}
      </Row>
    </Form>
  );
};

export default SignDocumentsFilterForm;
